export const symbolActionTypes = {
    UPDATEDATA: "STOCK_UPDATEDATA",
    UPDATEDATACHART: "STOCK_UPDATEDATACHART",
    UpdatePriceChart: "STOCK_UPDATEPRICECHART",
    UpdatePutThroughInfo: "STOCK_UPDATEPUTTHROUGHINFO",
    UpdateDataTPRL: "STOCK_UPDATEDATA_TPRL",
}

export const updateSymbolInfos = (newInfos, isInit) => {
    return {
        type: symbolActionTypes.UPDATEDATA,
        payload: { data: newInfos, isInit: isInit }
    }
};

export const updateSymbolChart = (newInfos) => {
    return {
        type: symbolActionTypes.UPDATEDATACHART,
        payload: newInfos
    }
};


export const updateSymbolPriceChart = (newInfos) => {
    return {
        type: symbolActionTypes.UpdatePriceChart,
        payload: newInfos
    }
};

export const updatePutThroughInfo = (putThroughInfo) => {
    return {
        type: symbolActionTypes.UpdatePutThroughInfo,
        payload: putThroughInfo
    }
};

export const updateSymbolTPRLInfos = (newInfos, isInit) => {
    return {
        type: symbolActionTypes.UpdateDataTPRL,
        payload: { data: newInfos, isInit: isInit }
    }
};